import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import { WhatIs, EverythingYouNeed, WhyTime2Cash } from "@/components/site/Features";
import { LocalNeeds, Jobs, Shops, Marketplace, WalletSection } from "@/components/site/Modules";
import { Safety, HowItWorks } from "@/components/site/Safety";
import { Screenshots, Testimonials } from "@/components/site/Social";
import { FAQ, DownloadSection } from "@/components/site/ClosingBlocks";
import { LiveStats, CommunityImpact, Announcements, Newsletter } from "@/components/site/HomeExtras";
import { useHashScroll, Reveal } from "@/components/site/PageChrome";

export default function Home() {
  useHashScroll();
  return (
    <>
      <Hero />
      <TrustBar />
      <Reveal><WhatIs /></Reveal>
      <Reveal><EverythingYouNeed /></Reveal>
      <Reveal><LiveStats /></Reveal>
      <Reveal><LocalNeeds /></Reveal>
      <Reveal><Jobs /></Reveal>
      <Reveal><Shops /></Reveal>
      <Reveal><Marketplace /></Reveal>
      <Reveal><WalletSection /></Reveal>
      <Reveal><Safety /></Reveal>
      <Reveal><WhyTime2Cash /></Reveal>
      <Reveal><HowItWorks /></Reveal>
      <Reveal><Screenshots /></Reveal>
      <Reveal><CommunityImpact /></Reveal>
      <Reveal><Testimonials /></Reveal>
      <Reveal><Announcements /></Reveal>
      <Reveal><FAQ /></Reveal>
      <Reveal><DownloadSection /></Reveal>
      {/* <Reveal><Newsletter /></Reveal> */}
    </>
  );
}
